import { render, staticRenderFns } from "./SelectWork.vue?vue&type=template&id=06e84132&scoped=true&"
import script from "./SelectWork.vue?vue&type=script&lang=js&"
export * from "./SelectWork.vue?vue&type=script&lang=js&"
import style0 from "./SelectWork.vue?vue&type=style&index=0&id=06e84132&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e84132",
  null
  
)

export default component.exports